import { render, staticRenderFns } from "./PriceController.vue?vue&type=template&id=bf85c6b6&scoped=true&"
import script from "./PriceController.vue?vue&type=script&lang=js&"
export * from "./PriceController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85c6b6",
  null
  
)

export default component.exports